module.exports = __webpack_public_path__ + "5ee2fd61363f7b2feb2176f54307c41f.woff2";